import * as Yup from 'yup'

const schema = Yup.object().shape({
  company_who_can_sell: Yup.array()
    .of(Yup.string())
    .required('Campo obrigatório'),
})

export default schema
